<div class="copo-datacenter-filter">
	<label class="filter-number-label" for="filter-single-number-input">{{this.header}}</label>
	<div>
		<mat-form-field appearance="outline" class="copo-no-error-message filter-datacenter-text-container">
			<input matInput id="filter-single-number-input" type="text" spellcheck="false" autocomplete="off" [formControl]="searchValueControl" [placeholder]="this.header + '...'">
		</mat-form-field>
		<div class="info-invalid-value" *ngIf="!searchValueControl.valid" translate>datacenter-filter.invalid-number</div>
	</div>
</div>
